import { Checkbox } from "@jane/lib/src/components/form/Checkbox";
import {FC, useMemo} from "react";
import {
  LearnCard,
  LearnCardProgress,
  LearnCategory,
  LearnModule
} from "../../../lib/src/api/repositories/learn-repository";
import {EmployeeProgress} from "../pages/learn/LearnModuleDetailsPage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons";

export const ShowLearnEmployeeProgressModal: FC<{progress: EmployeeProgress, learnModule: LearnModule}> = (props) => {
  const cardProgress = useMemo(() => {
    return props.progress.assignment.card_progress?.filter(cp => cp.employee_id === props.progress.employee?.id) ?? []
  }, [props.progress])

  return <div className={"pb-4 overflow-y-scroll max-h-80vh"}>
    <div className={''}>
      <ComponentList progress={props.progress} learnModule={props.learnModule} chapter={null} cardProgress={cardProgress} />
    </div>
    {props.learnModule.chapters.map((chapter, i) => {
      return <div key={i}>
        <div className={'h-8 flex items-center text-sm font-medium'}>Hoofdstuk: {chapter}</div>
        <ComponentList progress={props.progress} learnModule={props.learnModule} chapter={chapter} cardProgress={cardProgress} />
      </div>
    })}
  </div>
}

const ComponentList: FC<{progress: EmployeeProgress, learnModule: LearnModule, cardProgress: LearnCardProgress[], chapter: string|null}> = props => {
  return <>
    {props.learnModule.components?.filter(c => c.chapter === props.chapter).sort((a,b) => a.order - b.order).map((component, j) => {
      return <div key={j} className={'pl-4 mb-4'}>
        <div className={'h-8 flex items-center font-medium'}>{component.name}</div>
        {component.cards?.sort((a,b) => a.order - b.order).map((c, k) => {
          const cardProgress = props.cardProgress.find(cp => cp.learn_module_card_uuid === c.id)
          return <div key={k} className={'ml-4 bg-white border border-slate-200 px-2 py-1 rounded-sm mb-2'}>
            <div className={'min-h-8 py-1 flex items-center'}>
              <div className={'h-6 w-6 bg-brand-primary text-brand-on-primary font-medium text-sm rounded-full flex items-center justify-center mr-2'}>{c.order}</div>
              <div className={'flex-1 text-sm font-medium text-brand-primary'}>{c.title}</div>
              {cardProgress?.finished_at && <div className={'text-xs font-medium bg-green-600 text-white px-1 h-5 rounded-sm flex items-center whitespace-nowrap'}><FontAwesomeIcon icon={faCircleCheck} className={'mr-1'} />Voltooid</div>}
            </div>
            {cardProgress && (c.type !== 'media' && c.type !== 'text') && <CardAnswer card={c} cardProgress={cardProgress}/>}
          </div>
        })}
      </div>
    })}
  </>
}

const CardAnswer: FC<{card: LearnCard, cardProgress: LearnCardProgress}> = props => {
  return <div className={'pl-8 min-h-8 py-1 text-sm'}>
    {(props.card.type === 'question' || props.card.type === 'media_question') && <CardAnswerQuestion card={props.card} cardProgress={props.cardProgress} />}
    {props.card.type === 'open' && <div className={'border-2 border-brand-primary bg-brand-surface rounded-sm px-3 py-1 min-h-8'}>
      {props.cardProgress.answer?.text ?? ''}
    </div>}
  </div>
}

const CardAnswerQuestion: FC<{card: LearnCard, cardProgress: LearnCardProgress}> = props => {
  const options = props.card.properties.options as string[]|null ?? []
  const openFields = props.card.properties.open_fields as number[]|null ?? []
  const selected = props.cardProgress.answer?.selected as number|number[]|null ?? []
  return <div>
    {props.card.description}
    <div className={'ml-4'}>
      {options.map((v, k) => {
        const isChecked = Array.isArray(selected) ? selected.includes(k) : selected === k
        return <div>
          <div className={''}>
            <Checkbox
              label={v}
              checked={isChecked}
              onChange={() => {}}
            />
            {isChecked && openFields.includes(k) && <div className={'ml-10 border-2 border-brand-primary bg-brand-surface rounded-sm px-3 py-1 min-h-8'}>
              {props.cardProgress.answer?.text ?? ''}
            </div>}
          </div>
        </div>
      })}
    </div>
  </div>
}

